import { render, staticRenderFns } from "./ViewLabResults.vue?vue&type=template&id=152d0c3a&"
import script from "./ViewLabResults.vue?vue&type=script&lang=js&"
export * from "./ViewLabResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports